import axios, { AxiosError } from 'axios'
import config from 'config'
import getPortal from 'utils/getPortal'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'
import { defaultLosJsonHeaders } from '../requestHeaders'

export default async function getLeadsCount() {
    try {
        const { data } = await axios.get(
            `${config.API_BASE_URL}/api/v3/applications/leads-count/new-leads-count/`,
            {
                withCredentials: true,
                params: {
                    portal: getPortal(),
                },
                headers: defaultLosJsonHeaders(),
            },
        )

        return data
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to get leads count: ${axiosError.message}`,
            axiosError,
        )

        throw error
    }
}
